import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ContainerHeader from 'components/ContainerHeader';
import { HelpModals } from 'components/HelpModals';
import { useGetLapSponsorshipReport } from 'components/Participants/gql/useGetLapSponsorshipReport.mutation';
import { PrintParticipants } from 'components/Participants/PrintSpectators';
import { Table } from 'components/Table';
import Text from 'components/Text';
import Export from 'pages/app/Tickets/export';
import { Column } from '../../Header/StyledHeader';

const PanelHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px 40px 0;
`;

const LapSponsorshipTabPanel = ({ optionId, event, lapSponsorship }) => {
  const [lapSponsorshipReport, setLapSponsorshipReport] = useState();

  const getLapSponsorshipReport = useGetLapSponsorshipReport();

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await getLapSponsorshipReport(optionId);
        setLapSponsorshipReport(response?.data?.getLapSponsorshipReport);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    };

    if (optionId) {
      getData();
    }
  }, [getLapSponsorshipReport, optionId]);

  const columns = [
    { key: 'lap', label: 'Lap' },
    { key: 'lapText', label: 'Sponsored By' },
    { key: 'lap_price', label: 'Lap Price' },
    { key: 'purchaser_name', label: "Purchaser's Name" },
  ];

  function renderRows(sponsorship) {
    return {
      lap: sponsorship?.name,
      lapText: sponsorship?.lap_text,
      lap_price: sponsorship?.price,
      purchaser_name: sponsorship?.purchaser,
    };
  }

  const payoutColumns = [
    { label: 'Title', key: 'title' },
    { label: 'Amount', key: 'amount' },
  ];

  const lapSponsorshipData = lapSponsorship
    ? lapSponsorship
    : {
        id: optionId,
        name: lapSponsorshipReport?.name,
        action: 'getLapSponsorshipReport',
      };

  return (
    <>
      <PanelHeader>
        <Column noBorder>
          <Export
            event={event}
            date={lapSponsorshipReport?.event?.start_date}
            disabled={!lapSponsorshipReport?.data?.length}
            lapSponsorshipData={lapSponsorshipData}
          />

          <PrintParticipants
            eventId={optionId}
            date={lapSponsorshipReport?.event?.start_date}
            disable={!lapSponsorshipReport?.data?.length}
            lapSponsorshipData={lapSponsorshipData}
          />

          <HelpModals />
        </Column>
      </PanelHeader>

      <div style={{ padding: '0 20px' }}>
        <ContainerHeader
          borderWidth={'1px'}
          style={{ position: 'relative', width: '97%' }}
        >
          <Text
            type="heading"
            color="#3C4144"
            inlineStyle={{ marginRight: 25, whiteSpace: 'nowrap' }}
          >
            {lapSponsorshipReport?.name?.includes('Print')
              ? lapSponsorshipReport.name.replace('Print', '')
              : lapSponsorshipReport?.name ?? 'Lap Sponsorship Report'}
          </Text>
        </ContainerHeader>
        <div style={{ padding: 20 }}>
          <Table
            items={lapSponsorshipReport?.payouts}
            columns={payoutColumns}
            renderRows={(payout) => ({
              title: `${payout.title} payout`,
              amount: payout.amount,
            })}
            customPadding="15px 4px"
          />
        </div>

        {lapSponsorshipReport?.data?.length ? (
          <div style={{ padding: 20 }}>
            <Table
              items={lapSponsorshipReport?.data}
              columns={columns}
              renderRows={renderRows}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default LapSponsorshipTabPanel;
